import { render, staticRenderFns } from "./successDialog.vue?vue&type=template&id=071d8b81&lang=pug"
import script from "./successDialog.vue?vue&type=script&lang=js"
export * from "./successDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports